import { Compass, Feather, Leaf } from "lucide-react";
import { cn } from "../../../lib/utils";

const ORNAMENT = { leaf: Leaf, feather: Feather, compass: Compass } as const;

/**
 * A divider with a little character: a hairline that fades in from both sides
 * toward a small ornament (from the owl's world). Decorative only.
 */
const SectionDivider = ({ ornament = "leaf", className }: { ornament?: keyof typeof ORNAMENT; className?: string }) => {
  const Icon = ORNAMENT[ornament];
  return (
    <div aria-hidden data-testid="section-divider" className={cn("flex items-center gap-3", className)}>
      <span className="h-px flex-1 bg-gradient-to-r from-transparent via-border to-border rtl:bg-gradient-to-l" />
      <span className="inline-flex h-7 w-7 items-center justify-center rounded-full border border-border/70 bg-card text-primary/60 shadow-[0_1px_2px_rgba(0,0,0,0.04)]">
        <Icon className="h-3.5 w-3.5" />
      </span>
      <span className="h-px flex-1 bg-gradient-to-l from-transparent via-border to-border rtl:bg-gradient-to-r" />
    </div>
  );
};

export default SectionDivider;
